// A PDF shown inside the app (ERP-78): a generated document, before anyone saves or sends it.
// In a dialog rather than a new tab, which a browser may block when it follows a network call.
import { useEffect, useMemo } from "react";
import { Icon } from "./ui";

export function PdfPreview({ blob, title, onClose }: { blob: Blob; title: string; onClose: () => void }) {
  const url = useMemo(() => URL.createObjectURL(blob), [blob]);
  useEffect(() => () => URL.revokeObjectURL(url), [url]);
  useEffect(() => {
    const esc = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onClose]);
  return (
    <div className="pdf-preview" role="dialog" aria-label={title}>
      <div className="pdf-preview-bar">
        <b>{title}</b>
        <div className="row" style={{ gap: 6 }}>
          <a className="btn btn-sm" href={url} download={`${title}.pdf`}>
            Download
          </a>
          <button type="button" className="icon-btn" aria-label="Close" onClick={onClose}>
            <Icon name="x" />
          </button>
        </div>
      </div>
      <iframe title={title} src={url} />
    </div>
  );
}
